import * as tslib_1 from "tslib";
// Core components
import { OnDestroy, OnInit } from "@angular/core";
// Third party components
import { FieldType } from "@ngx-formly/core";
import { TranslateService } from "@ngx-translate/core";
// Custom components
import { ActivatedRoute } from "@angular/router";
import { CondoStructuresService } from "src/app/modules/properties/condo-structures.service";
/**
 * Script start
 */
var SelectStructureTypeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SelectStructureTypeComponent, _super);
    function SelectStructureTypeComponent(condoStructuresService, translateService, activatedRoute) {
        var _this = _super.call(this) || this;
        _this.condoStructuresService = condoStructuresService;
        _this.translateService = translateService;
        _this.activatedRoute = activatedRoute;
        _this.subscriptions = [];
        _this.items = [];
        _this.dataIsLoading = true;
        return _this;
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    SelectStructureTypeComponent.prototype.ngOnInit = function () {
        var _this = this;
        var condoStructureId = this.activatedRoute.snapshot.params.mappingFormActiveSection
            .split("/")[1];
        this.subscriptions.push(this.condoStructuresService
            .getCondoStructuresListForSelect(condoStructureId)
            .subscribe(function (res) {
            if (res.status) {
                _this.items = (res.data && res.data.items) || res.items || [];
                _this.dataIsLoading = false;
            }
        }));
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    SelectStructureTypeComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Handle onChange event
     *
     * @since 1.0.0
     */
    SelectStructureTypeComponent.prototype.onChange = function (value) {
        if (!value) {
            return;
        }
        if (!this.model.connessioni) {
            this.model.connessioni = [];
        }
        if (!this.model.connessioni.includes(value)) {
            // Add connection
            this.model.connessioni.push(value);
        }
        else if (this.model.connessioni.includes(value)) {
            // Remove connection
            this.model.connessioni.splice(this.model.connessioni.indexOf(value), 1);
        }
        // Set form value
        if (this.form.controls.connessioni) {
            this.form.controls.connessioni.setValue(this.model.connessioni);
        }
    };
    return SelectStructureTypeComponent;
}(FieldType));
export { SelectStructureTypeComponent };
